import type { ProductSortField } from '@/gql/graphql';
import { activeVisibility, decimal, int, oneOf, text, uuid } from '@/hooks/useUrlState';

export type ProductsSortColumn = 'name' | 'price' | 'tax' | 'isActive';

/** DataGrid column `id` → GraphQL `ProductSortField` for server-side sort; its keys are the values `sort` accepts. */
export const PRODUCT_COLUMN_SORT: Record<ProductsSortColumn, ProductSortField> = {
  name: 'NAME',
  price: 'PRICE',
  tax: 'TAX',
  isActive: 'IS_ACTIVE',
};

export const PRODUCTS_DEFAULT_SORT: { sort: ProductsSortColumn; dir: 'asc' | 'desc' } = { sort: 'name', dir: 'asc' };

/** The /products query string, in this order (see README "List pages, URL state"). */
export const productsUrlSchema = {
  search: text(),
  priceMin: decimal(),
  priceMax: decimal(),
  taxMin: decimal(),
  taxMax: decimal(),
  category: uuid(),
  show: activeVisibility('active'),
  sort: oneOf(PRODUCT_COLUMN_SORT, PRODUCTS_DEFAULT_SORT.sort),
  dir: oneOf<'asc' | 'desc', 'asc' | 'desc'>({ asc: true, desc: true }, PRODUCTS_DEFAULT_SORT.dir),
  page: int({ min: 1 }, 1),
  size: int({ min: 1, max: 500 }, 25),
};

/** The keys that live in the collapsible Filters panel: the panel opens on mount when any is set. */
export const PRODUCTS_ADVANCED_KEYS = [
  'show',
  'category',
  'priceMin',
  'priceMax',
  'taxMin',
  'taxMax',
] as const satisfies readonly (keyof typeof productsUrlSchema)[];
